<template>
  <el-dialog
    ref="ticketDialog"
    title="异常改签-确认行程信息"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    :append-to-body="true"
    width="68%"
  >
    <el-descriptions title="原班次信息" :column="3" size="small">
      <el-descriptions-item label="班次时间">{{ nInfo.flightPlanTime }}</el-descriptions-item>
      <el-descriptions-item label="乘客端显示时间(门到门模式)">
        {{ oldDoorTime }}
      </el-descriptions-item>
      <el-descriptions-item label="座位号">{{ nInfo.seateStr }}</el-descriptions-item>
      <el-descriptions-item label="下单人手机号">{{ nInfo.mobilePhone }}</el-descriptions-item>
      <el-descriptions-item label="票价全额">{{ nInfo.payAmountYuan }}</el-descriptions-item>
      <el-descriptions-item label="接服务费">{{ nInfo.meetOrderAmountYuan }}</el-descriptions-item>
      <el-descriptions-item label="送服务费">{{ nInfo.sendOrderAmountYuan }}</el-descriptions-item>
    </el-descriptions>

    <div style="padding-top: 20px">
      <el-descriptions title="新班次信息" size="small" />
      <el-row :gutter="10">
        <el-col :span="10">班次时间: {{ info.departureDate + ' ' + info.departureTime }}</el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="10">新班次乘客端显示时间(门到门模式): {{ newDoorTime }}</el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="10">
          座位号:
          <div class="seatContainer">
            <el-row v-for="(iterm, index) in seatArray" :key="index">
              <el-col
                v-for="(seat, index2) in iterm"
                :key="index2"
                class="seatBox"
                @click.native="selectSeatEvent(seat)"
              >
                <span v-if="seat.state === -2" class="seatSpan">
                  <span
                    class="seatText"
                    style="color: #ffffff; -webkit-user-select: none; user-select: none"
                  >
                    {{ seat.seatNo }}号座
                    <br />
                    ￥{{ seat.sellingPrice }}
                  </span>
                  <span v-if="seat.state === -2" class="unableSeat seatIcon"></span>
                </span>
                <span v-else-if="seat.state === -1" class="seatSpan"><!--  过道 --></span>
                <span v-else-if="seat.state === 0" class="seatSpan">
                  <span class="seatText">
                    {{ seat.seatNo }}号座
                    <br />
                    ￥{{ seat.sellingPrice }}
                  </span>
                  <span class="ableSeat seatIcon"></span>
                </span>
                <span v-else-if="seat.state === 1" class="seatSpan">
                  <span class="seatText">
                    {{ seat.seatNo }}号座
                    <br />
                    ￥{{ seat.sellingPrice }}
                  </span>
                  <span class="soldSeat seatIcon"></span>
                </span>
                <span v-else-if="seat.state === 2" class="seatSpan">
                  <span class="seatText">
                    {{ seat.seatNo }}号座
                    <br />
                    ￥{{ seat.sellingPrice }}
                  </span>
                  <span class="lockSeat seatIcon"></span>
                </span>
                <span v-else-if="seat.state === 3" class="seatSpan">
                  <span class="seatText">
                    {{ seat.seatNo }}号座
                    <br />
                    ￥{{ seat.sellingPrice }}
                  </span>
                  <span class="seat seatIcon"></span>
                </span>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <div class="tipsBox">
        <img style="width: 20px; height: 20px" src="./static/tips.png" />
        <span>先选择座位，选择的座位数需和乘车人数相同！</span>
      </div>
      <el-table :data="seateSelectArr" size="mini" border>
        <el-table-column label="票价全额" align="center" prop="payAmountYuan" />
        <el-table-column label="接服务" align="center" prop="meetOrderAmountYuan" />
        <el-table-column label="送服务" align="center" prop="sendOrderAmountYuan" />
        <el-table-column label="增值服务" align="center" prop="insureAmount" />
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="cancel">取 消</el-button>
      <el-button type="primary" size="small" @click="handleSubmit">确认改签</el-button>
    </div>
    <el-dialog
      title="确定改签吗？"
      :visible.sync="submitDialogVisible"
      width="30%"
      :before-close="handleSubmitClose"
      center
      append-to-body
    >
      <template v-if="pickerOrderTip || carryOrderTip">
        <p>该订单关联的摆渡订单已有司机接单，改签请电话联系摆渡司机确认！</p>
        <p v-if="pickerOrderTip">{{ pickerOrderTip }}</p>
        <p v-if="carryOrderTip">{{ carryOrderTip }}</p>
        <p v-if="cityOrderTip">{{ cityOrderTip }}</p>
      </template>
      <el-input
        v-model="sendMsgContent"
        type="textarea"
        placeholder="请填写改签原因！"
        maxlength="50"
        show-word-limit
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleSubmitClose">取 消</el-button>
        <el-button type="primary" @click="submit" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
  import { getSeatState } from '@/api/transport/ticketsche'
  import { changeTicket } from '@/api/intercityorder'
  import dayjs from 'dayjs'
  export default {
    name: 'changeTicketDetails',
    props: {
      insureDates: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        visible: false,
        info: {},
        nInfo: {
          seateStr: ''
        },
        seateStr: '',
        data: [],
        seatArray: [],
        selectState: 0, // 0-无选中，1-空座位选中，2-锁定选中
        selectedSeatArray: [], // 选中的座位
        submitDialogVisible: false,
        sendMsgToCustom: true,
        sendMsgContent: '',
        loading: false,
        statusArr: ['待出发', '接人中', '待乘客上车', '行程中'] // 需要提示语的状态
      }
    },
    computed: {
      // 是否显示摆渡订单提示信息(接)
      pickerOrderTip() {
        // 有摆渡订单
        if (this.nInfo.pickUpInfo && this.nInfo.pickUpInfo.length > 0) {
          const obj = this.nInfo.pickUpInfo.find(
            (item) => item.pickupType === '接人' && this.statusArr.includes(item.status)
          )
          console.log('123:', obj)
          if (obj) {
            return `接单司机：${obj.carMsg} - ${obj.driverMsg} - ${obj.status}`
          }
        }
        return ''
      },
      // 是否显示摆渡订单提示信息(送)
      carryOrderTip() {
        if (this.nInfo.pickUpInfo && this.nInfo.pickUpInfo.length > 0) {
          const obj = this.nInfo.pickUpInfo.find(
            (item) => item.pickupType === '送人' && this.statusArr.includes(item.status)
          )
          if (obj) {
            return `接单司机：${obj.carMsg} - ${obj.driverMsg} - ${obj.status}`
          }
        }
        return ''
      },
      cityOrderTip() {
        if (this.nInfo.trainsInfo && this.nInfo.orderBaseInfo) {
          return `城际司机：${this.nInfo.trainsInfo.carMsg} - ${this.nInfo.trainsInfo.driverMsg} - ${this.nInfo.orderBaseInfo.orderState}`
        }
        return ''
      },
      seateSelectArr() {
        const data = this.selectedSeatArray.map((item) => {
          const onData = {
            meetOrderAmountYuan: this.nInfo.meetOrderAmountYuan,
            sendOrderAmountYuan: this.nInfo.sendOrderAmountYuan,
            payAmountYuan: item.sellingPrice
          }
          if (this.insureForChangeStr !== null && this.insureForChangeStr !== '') {
            onData.insureAmount = this.insureForChangeStr
          }
          return onData
        })
        return data
      },
      insureForChangeStr() {
        const insureStr = 0
        if (this.insureDates !== null && this.insureDates.length > 0) {
          // this.insureDates.forEach((item) => {
          //   item.insurancePrice && (insureStr += parseFloat(item.insurancePrice))
          //   /* let  insureStr = item.insuredName+ item.productCode
          //   insureStrList.push(insureStr) */
          // })
          return this.insureDates[0].insurancePrice
        }
        return insureStr
      },
      oldDoorTime() {
        const { preferredDepartureStart, preferredDepartureEnd } = this.nInfo
        let timeStr = '-'
        if (preferredDepartureEnd && preferredDepartureEnd) {
          const date = dayjs(preferredDepartureStart).format('YYYY-MM-DD')
          const startTime = dayjs(preferredDepartureStart).format('HH:mm')
          const endTime = dayjs(preferredDepartureEnd).format('HH:mm')
          timeStr = `${date} ${startTime}-${endTime}`
        }
        return timeStr
      },
      newDoorTime() {
        const { preferredDepartureStart, preferredDepartureEnd } = this.info
        let timeStr = '-'
        if (preferredDepartureEnd && preferredDepartureEnd) {
          const date = dayjs(preferredDepartureStart).format('YYYY-MM-DD')
          const startTime = dayjs(preferredDepartureStart).format('HH:mm')
          const endTime = dayjs(preferredDepartureEnd).format('HH:mm')
          timeStr = `${date} ${startTime}-${endTime}`
        }
        return timeStr
      }
    },
    methods: {
      init(row, row1) {
        console.log('改签的数据', row, row1)

        this.info = row
        this.nInfo = row1
        this.visible = true
        this.nInfo.seateStr = this.nInfo.seatNames.join(',')
        this.$nextTick(() => {
          getSeatState(row.id).then((res) => {
            this.seatArray = res.data
          })
        })
      },
      cancel() {
        this.visible = false
        this.selectedSeatArray = []
      },
      handleSubmit() {
        this.submitDialogVisible = true
      },
      submit() {
        const adOnData = {
          oldOrderId: this.nInfo.orderId,
          sectionId: this.info.id,
          seatDtos: this.selectedSeatArray.map((item) => item.seatNo),
          sendMsgToCustom: this.sendMsgToCustom,
          sendMsgContent: this.sendMsgContent,
          preferredDepartureStart: this.info.preferredDepartureStart,
          preferredDepartureEnd: this.info.preferredDepartureEnd
        }
        this.loading = true
        changeTicket(adOnData).then((resp) => {
          if (resp.code === 0) {
            this.$message.success('改签成功')
            this.$emit('refresh')
            this.visible = false
            this.submitDialogVisible = false
            this.selectedSeatArray = []
          }

          this.loading = false
        })
      },
      // 选座判断
      selectSeatEvent(seat) {
        //  selectState  0-无选中，1-空座位选中，2-锁定选中
        // seatState  -2司机位  -1走道  0可选  1已售  2锁定  3选中
        // 空座选中判断
        if (seat.state === 0) {
          if (this.selectState !== 2) {
            seat.state = 3
            this.selectState = 1
            this.selectedSeatArray.push(seat)
            return
          } else {
            this.$message.error('请选择同状态座位进行操作！')
          }
        }
        if (seat.state === 3) {
          // 选中取消判断
          if (this.selectState === 1) {
            seat.state = 0
            this.removeSeat(this.selectedSeatArray, seat)
            if (this.selectedSeatArray.length === 0) {
              this.selectState = 0
            }
            return
          }
          if (this.selectState === 2) {
            // 锁定选中取消判断
            seat.state = 2
            this.removeSeat(this.selectedSeatArray, seat)
            if (this.selectedSeatArray.length === 0) {
              this.selectState = 0
            }
            return
          }
        }
        // 锁座选中判断
        if (seat.state === 2) {
          if (this.selectState !== 1) {
            seat.state = 3
            this.selectState = 2
            this.selectedSeatArray.push(seat)
          } else {
            this.$message.error('请选择同状态座位进行操作！')
          }
        }
      },
      // 取消选中辅助方法
      removeSeat(array, val) {
        let index = -1
        for (let i = 0; i < array.length; i++) {
          if (array[i].seatNo === val.seatNo) {
            index = i
            break
          }
          index = -1
        }
        if (index > -1) {
          array.splice(index, 1)
        }
      },
      handleClose(done) {
        this.visible = false
        this.selectedSeatArray = []
        done()
      },
      handleSubmitClose(done) {
        this.submitDialogVisible = false
        this.sendMsgContent = ''
        done()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tipsBox {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #9f9f9f;
    margin: 0 0 10px 10px;
  }
  .tipsBox span {
    margin-left: 5px;
  }
  /* 选中 */
  .seat {
    background: url('../../../static/选中.png') center center no-repeat;
  }

  /* 无效 */
  .unableSeat {
    background: url('../../../static/司机.png') center center no-repeat;
  }

  /* 锁定 */
  .lockSeat {
    background: url('../../../static/锁定.png') center center no-repeat;
  }

  /* 已售 */
  .soldSeat {
    background: url('../../../static/已售.png') center center no-repeat;
  }

  /* 可选 */
  .ableSeat {
    background: url('../../../static/可选.png') center center no-repeat;
  }

  .seatBox {
    text-align: center;
    height: 80px;
    width: 80px;
    font-size: 15px;
    display: flex;
    margin: 0;
    align-items: center;
    justify-content: center;
  }

  .seatContainer {
    margin: 10px;
  }

  .feel {
    font-size: 15px;
    color: #8a979e;
  }

  .seatSpan {
    text-align: center;
    display: block;
    height: 80%;
    align-items: center;
    justify-content: center;
  }

  .seatIcon {
    height: 50%;
    width: 100%;
    display: block;
    background-size: 100%, 100%;
  }

  .seatText {
    font-size: 10px;
    /*color: #00ff02;*/
  }

  .seatIconEp {
    height: 70%;
    width: 70%;
    text-align: center;
    display: block;
    background-size: 100%, 100%;
  }
  ::v-deep .el-textarea__inner {
    height: 130px;
  }
</style>
